import { Text } from '@chakra-ui/react';
import { FT_PI_BB_CCUI_TRIP_ADVISOR } from '@whitbread-eos/api';
import { useFeatureToggle, useStaticHotelInformation } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import BottomReviewSection from './BottomReviewSection';
import TopRatingSection from './TopRatingSection';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export var TripAdvisorReview = _ref => {
  var _ref$isTopSection = _ref.isTopSection,
    isTopSection = _ref$isTopSection === void 0 ? true : _ref$isTopSection;
  var _useStaticHotelInform = useStaticHotelInformation(),
    tripAdvisorReviews = _useStaticHotelInform.tripAdvisorReviews,
    isLoading = _useStaticHotelInform.isLoading,
    isError = _useStaticHotelInform.isError,
    error = _useStaticHotelInform.error,
    brand = _useStaticHotelInform.brand,
    title = _useStaticHotelInform.title;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _useFeatureToggle = useFeatureToggle(),
    isTripAdvisorReviewEnabled = _useFeatureToggle[FT_PI_BB_CCUI_TRIP_ADVISOR];
  if (isLoading) {
    return _jsx(Text, {
      children: t('searchresults.list.hotel.loading')
    });
  }
  if (isError) {
    return _jsx(Text, {
      children: error === null || error === void 0 ? void 0 : error.message
    });
  }
  return isTripAdvisorReviewEnabled ? _jsx(_Fragment, {
    children: isTopSection ? _jsx(TopRatingSection, {
      tripAdvisorData: tripAdvisorReviews
    }) : _jsx(BottomReviewSection, {
      tripAdvisorData: tripAdvisorReviews,
      brand: brand,
      title: title
    })
  }) : null;
};